import { unsafeEntries } from './typeUtils';

export const stringifyIdRecord = (id: Record<string, string | undefined>) =>
  JSON.stringify(unsafeEntries(id).sort(([a], [b]) => a.localeCompare(b)));

export const truncate = (text: string, options: { length: number; omission?: string }) => {
  if (text.length <= options.length) return text;
  return text.slice(0, options.length) + (options.omission ?? '...');
};

export const fromCamelCase = (input: string): string => {
  if (!input) return '';

  // If snake_case or kebab-case, return as-is
  if (input.includes('_') || input.includes('-')) {
    return input;
  }

  return (
    input
      // Insert space before camelCase / PascalCase transitions
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      // Handle consecutive capitals followed by lowercase (e.g. "URLValue")
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      // Capitalize first letter of each word
      .replace(/\b\w/g, char => char.toUpperCase())
      .trim()
  );
};

export const toCamelCase = (input: string): string => {
  if (!input) return '';

  // If input contains separators (_,-,space), normalize and convert
  if (/[_\-\s]/.test(input)) {
    const words = input.split(/[_\-\s]+/).filter(Boolean);
    return words
      .map((word, index) => {
        const lower = word.toLowerCase();
        return index === 0 ? lower : lower.charAt(0).toUpperCase() + lower.slice(1);
      })
      .join('');
  }

  // Single word or already camelCase: lowercase entire word if all caps
  if (input === input.toUpperCase()) {
    return input.toLowerCase();
  }

  // Otherwise, lowercase only the first letter
  return input.charAt(0).toLowerCase() + input.slice(1);
};
